import { Title, Image, Group } from '@mantine/core';
import { useNavigate } from 'react-router-dom';
import logo from '/ainigma-logo-small.png';
import { useTranslation } from 'react-i18next';
import { SignInForm } from '../../components/medplum-react/auth/SignInForm';
import { Loading, useMedplumProfile } from '@medplum/react';
import { useEffect } from 'react';

export function SignInPage(): JSX.Element {
  const navigate = useNavigate();
  const { t } = useTranslation(['signin-page']);
  const profile = useMedplumProfile();

  useEffect(() => {
    if (profile) {
      navigate('/');
    }
  }, [profile, navigate]);

  if (profile) {
    return <Loading />;
  }

  return (
    <SignInForm
      // Configure according to your settings
      googleClientId="921088377005-3j1sa10vr6hj86jgmdfh2l53v3mp7lfi.apps.googleusercontent.com"
      onSuccess={() => navigate('/')}
      scope="openid offline_access"
      onForgotPassword={() => navigate('/forgot-password')}
    >
      <Group>
        <Image src={logo} alt="Logo" w={32} h={32} />
        <Title>{t('signinMessage', { ns: 'signin-page' })}</Title>
      </Group>
    </SignInForm>
  );
}
